var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationMark = function SvgExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exclamation_mark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.607 11.966 11.11 2.857c-.543-.91-1.832-1.236-2.782-.715-.34.195-.61.455-.746.715l-5.496 9.109c-.543.91-.203 2.147.746 2.667.34.195.679.26 1.018.26h10.924c1.153 0 2.035-.91 2.035-1.952.068-.39-.068-.715-.203-.975m-7.26.325c-.407 0-.679-.26-.679-.65 0-.391.272-.651.679-.651s.678.26.678.65-.271.65-.678.65m.678-3.253c0 .39-.271.65-.678.65s-.679-.26-.679-.65V6.436c0-.39.272-.651.679-.651s.678.26.678.65z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exclamation_mark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.828.893h16v16h-16z"
  })))));
};
export default SvgExclamationMark;